import { render, staticRenderFns } from "./textInput.vue?vue&type=template&id=0c35ed4b&scoped=true&"
import script from "./textInput.vue?vue&type=script&lang=js&"
export * from "./textInput.vue?vue&type=script&lang=js&"
import style0 from "./textInput.vue?vue&type=style&index=0&id=0c35ed4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c35ed4b",
  null
  
)

export default component.exports